import { AbstractRectangleValuedItem } from "./AbstractRectangleValuedItem";

export class NotImplementedItem extends AbstractRectangleValuedItem {
  constructor(public trueTypeKey: string, public readonly source: any) {
    super("NotImplementedItem", null);
  }
 
  protected createCloneInstance(): NotImplementedItem {
    return new NotImplementedItem(this.trueTypeKey, this.source);
  }
}
